export default [
  {
    path: '/',
    component: '@/pages/home/index',
    exact: true,
  },
  {
    path: '/login',
    component: '@/pages/login/index',
    layout: false,
    exact: true,
  },
  {
    path: '/register',
    component: '@/pages/register/index',
    layout: false,
    exact: true,
  },
  {
    path: '/com',
    component: '@/pages/com/index',
    exact: true,
  },
  {
    path: '/cart',
    component: '@/pages/cart',
    exact: true,
  },
  {
    path: '/category',
    component: '@/pages/category',
    exact: true,
  },
  {
    path: '/info/:informationId',
    component: '@/pages/info',
    exact: true,
  },
  {
    path: '/info/list/:informationId',
    component: '@/pages/infoList',
    exact: true,
  },
  {
    path: '/terms/:type',
    component: '@/pages/terms',
    exact: true,
  },
  {
    path: '/product/:spuCode',
    exact: true,
    component: '@/pages/productDetail/index',
  },
  {
    path: '/product/com/:spuCode',
    exact: true,
    component: '@/pages/productDetailCom/index',
  },
  {
    path: '/order',
    component: '@/pages/order',
    exact: true,
  },
  {
    path: '/pay',
    component: '@/pages/pay',
    name: '收银台',
    layout: false,
    exact: true,
  },
  {
    path: '/result',
    component: '@/pages/result',
    layout: false,
    exact: true,
  },
  {
    path: '/manage',
    layout: false,
    component: '@/layouts/MCLayout',
    name: 'pages.userCenter.name',
    routes: [
      {
        path: '/manage/oc',
        name: 'pages.userCenter.oc.name',
        routes: [
          {
            path: '/manage/oc',
            redirect: '/manage/oc/order',
            hideInMenu: true,
          },
          {
            path: '/manage/oc/order',
            name: 'pages.userCenter.oc.order',
            exact: true,
            component: '@/pages/orderList',
          },
          {
            path: '/manage/oc/order/detail/:orderId',
            name: 'page.userCenter.orderDetail',
            exact: true,
            layout: false,
            hideInMenu: true,
            component: '@/pages/orderDetail',
          },
          {
            path: '/manage/oc/intention',
            name: 'pages.userCenter.oc.intention',
            exact: true,
            component: '@/pages/intention',
          },
        ],
      },
      {
        path: '/manage/cc',
        name: 'pages.userCenter.cc.name',
        routes: [
          {
            path: '/manage/cc',
            redirect: '/manage/cc/collect',
            hideInMenu: true,
          },
          {
            path: '/manage/cc/collect',
            name: 'pages.userCenter.cc.collect',
            exact: true,
            component: '@/pages/collection',
          },
        ],
      },
      {
        path: '/manage/ac',
        name: 'pages.userCenter.ac.name',
        routes: [
          {
            path: '/manage/ac',
            redirect: '/manage/ac/account',
            hideInMenu: true,
          },
          {
            path: '/manage/ac/account',
            name: 'pages.userCenter.ac.account.name',
            exact: true,
            component: '@/pages/account',
          },
          {
            path: '/manage/ac/security',
            name: 'pages.userCenter.ac.security.name',
            exact: true,
            component: '@/pages/security',
          },
          {
            path: '/manage/ac/security/update-pay',
            name: '修改支付密码',
            exact: true,
            hideInMenu: true,
            component: '@/pages/security/update-pay',
          },
        ],
      },
      {
        path: '/manage/notification',
        name: 'pages.userCenter.notification.name',
        routes: [
          {
            path: '/manage/notification',
            redirect: '/manage/notification/list',
            hideInMenu: true,
          },
          {
            path: '/manage/notification/list',
            name: 'pages.userCenter.notification.platform.name',
            exact: true,
            component: '@/pages/notification',
          },
        ],
      },
    ],
  },
  { component: '@/pages/404' },
];
